export const headers = token => {
    return {
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
  };


export default {
    // getAllFileFromContentLibByOwnerId: '/ContentLibrary/api/FileManager/GetAllFilesByOwnerId',
    // getAllFileFromContentLib: '/ContentLibrary/api/FileManager/GetAllFiles',
    // getAllDistinctOwnerIdFromContentLib: '/ContentLibrary/api/FileManager/GetAllDistinctOwnerId',
    // downloadGoogleDriveFile: '/ContentLibrary/api/FileManager/DownLoadGoogleDriveFile',
    // downloadGoogleDriveFileM: '/ContentLibrary/api/FileManager/DownLoadGoogleDriveFileMultiple',

    getAllFileFromContentLibByOwnerId: '/api/FileManager/GetAllFilesByOwnerId',
    getAllFileFromContentLib: '/api/FileManager/GetAllFiles',
    getAllDistinctOwnerIdFromContentLib: '/api/FileManager/GetAllDistinctOwnerId',
    downloadGoogleDriveFile: '/api/FileManager/DownLoadGoogleDriveFile',
    downloadGoogleDriveFileM: '/api/FileManager/DownLoadGoogleDriveFileMultiple',
};
